import "../blocks/gallerySection/gallerySection.css";
import GalleryCard from "./GalleryCard";

const GallerySection = ({
  galleryItems,
  onCreateGallery,
  onDeleteGalleryItem,
  onSelectGalleryItem,
}) => {
  if (!galleryItems) {
    return <p>Loading...</p>;
  }

  return (
    <div className="gallerySection">
      <div className="gallerySection__header">
        <h3 className="gallerySection__name">My album</h3>
        <button
          className="gallerySection__add-button"
          type="button"
          onClick={onCreateGallery}
        >
          + Add photos or videos
        </button>
      </div>
      {galleryItems.length === 0 ? (
        <p className="gallerySection__empty">
          Your album is empty. Upload some photos or videos to get started.
        </p>
      ) : (
        <div className="gallerySection__items">
          {galleryItems.map((item, index) => (
            <GalleryCard
              key={item._id}
              item={item}
              onDelete={onDeleteGalleryItem}
              onSelect={() => onSelectGalleryItem(index)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default GallerySection;
